<div class="complainForm">
  @if (data$ | async; as data) {
  <h1>{{ data.title }}</h1>
  } @if (data$ | async; as data) {
  <p>
    <a
      [href]="mediaUrl(mediaUrl$ | async)"
      download=""
      rel="noopener noreffer"
      target="_blank"
      type="application/octet-stream"
      >{{ data.linkName }} <mat-icon class="material-icons-sharp light warranty-icon">system_update_alt</mat-icon></a
    >
  </p>
  }
</div>
